import React from 'react';
import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

import { PropertyTextInput } from '@paragon/client-tools';

interface ScheduleGroupPropertiesProps {
  readonly scheduleGroupName: string | null;
  readonly setScheduleGroupName: (newScheduleLineGroupName: string | null) => void;
  readonly scheduleGroupNameError: boolean;
  readonly targetDate: string | null;
  readonly setTargetDate: (date: string | null) => void;
}

export function ScheduleGroupProperties(props: ScheduleGroupPropertiesProps) {
  const { scheduleGroupName, setScheduleGroupName, scheduleGroupNameError, targetDate, setTargetDate } = props;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <PropertyTextInput
        property="Schedule Group Name"
        value={scheduleGroupName ?? ''}
        submit={(newScheduleGroupName) => void setScheduleGroupName(newScheduleGroupName.trim())}
        error={scheduleGroupNameError}
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={targetDate ? dayjs(targetDate) : null}
          label="Target Date (optional)"
          onChange={(date) => void setTargetDate(date?.format('YYYY-MM-DD') ?? null)}
        />
      </LocalizationProvider>
    </Box>
  );
}
